import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import checkCirclePng from 'images/check-circle.png';
import './MessageModal.css';
import Button from 'components/shared/button/Button';

class MessageModal extends Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    icon: PropTypes.string,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
      .isRequired,
    onHide: PropTypes.func.isRequired,
  };

  static defaultProps = {
    icon: checkCirclePng,
  };

  handleOk = () => {
    if (this.props.onHide) {
      this.props.onHide();
    }
  };

  render() {
    return (
      <Modal show={this.props.show} className="message-modal">
        <Modal.Body>
          <div className="message-modal-container">
            <img src={this.props.icon} alt="message-modal-img" />
            <div className="h3">{this.props.message}</div>
            <div>
              <Button
                label="Ok"
                className="button-orange ok-button"
                onClick={this.handleOk}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default MessageModal;



// WEBPACK FOOTER //
// ./src/components/shared/modal/MessageModal.js